export function getContestMeta(contestNumber) {
    const num = parseInt(contestNumber, 10);
    const canonical = `${window.location.origin}/leaderboard/${contestNumber}`;

    switch (num) {
        case 15:
            return {
                title: 'Quantiacs Q15 Leaderboard — Futures & Bitcoin Futures Contest',
                description:
                    'View the final standings and historical performance of algorithmic trading strategies from the completed Quantiacs Q15 Futures and Bitcoin Futures contest.',
                canonical,
            };
        case 16:
            return {
                title: 'Quantiacs Q16 Leaderboard — Crypto Top-10 Long-Only Contest',
                description:
                    'Final standings and historical performance of quantitative long-only trading strategies competing with Top 10 Cryptocurrencies in the completed Q16 contest.',
                canonical,
            };
        case 17:
            return {
                title: 'Quantiacs Q17 Leaderboard — Crypto Top-10 Long-Short Contest',
                description:
                    'Final results of the completed Quantiacs Q17 contest. Review the performance of quantitative long-short algorithms traded on Top 10 Cryptocurrencies.',
                canonical,
            };
        case 18:
            return {
                title: 'Quantiacs Q18 Leaderboard — NASDAQ-100 Stock Long-Short Contest',
                description:
                    'Historical standings and performance metrics of long-short algorithmic trading strategies for NASDAQ-100 stocks in the completed Q18 contest.',
                canonical,
            };
        case 19:
            return {
                title: 'Quantiacs Q19 Leaderboard — NASDAQ-100 Stock Long-Short Contest',
                description:
                    'Final results and historical standings of algorithmic long-short strategies for NASDAQ-100 equities in the completed Quantiacs Q19 contest.',
                canonical,
            };
        case 20:
            return {
                title: 'Quantiacs Q20 Leaderboard — NASDAQ-100 Stock Long-Short Contest',
                description:
                    'View the final leaderboard standings of quantitative trading strategies based on NASDAQ-100 equities in the completed Q20 long-short contest.',
                canonical,
            };
        case 21:
            return {
                title: 'Quantiacs Q21 Leaderboard — NASDAQ-100 Stock Long-Short Contest',
                description:
                    'Final rankings and performance metrics for the completed Quantiacs Q21 NASDAQ-100 stock trading contest. Review historical strategy metrics.',
                canonical,
            };
        case 22:
            return {
                title: 'Quantiacs Q22 Leaderboard — S&P 500 Stock Long-Short Contest',
                description:
                    'Historical leaderboard standings of quantitative trading algorithms for S&P 500 stocks in the completed Quantiacs Q22 long-short contest.',
                canonical,
            };
        case 23:
            return {
                title: 'Quantiacs Q23 Leaderboard — S&P 500 Stock Long-Short Contest',
                description:
                    'Review the final standings of S&P 500 stock long-short trading algorithms from the completed Quantiacs Q23 contest.',
                canonical,
            };
        case 24:
            return {
                title: 'Quantiacs Q24 Leaderboard — Crypto Top-10 Long-Only Contest',
                description:
                    'Track live performance, returns, and Sharpe ratios of active long-only trading strategies competing on Top 10 Cryptocurrencies in Quantiacs Q24.',
                canonical,
            };
        case 25:
            return {
                title: 'Quantiacs Q25 Leaderboard — Live Crypto Top-10 Long-Only Contest',
                description:
                    'Track live performance, returns, and Sharpe ratios of long-only trading strategies competing on Top 10 Cryptocurrencies in Quantiacs Q25. Live contest period: October 1, 2026 to January 31, 2027.',
                canonical,
            };
        default:
            return {
                title: `Quantiacs Q${contestNumber} Leaderboard`,
                description: `View performance standings for Quantiacs Q${contestNumber} trading contest.`,
                canonical,
            };
    }
}
